import http from '@/helpers/Http';

export default {
    namespaced: true,
    state: {
        items: {
            data: [],
            meta: {},
            links: {},
        },
    },
    getters: {
        items: state => state.items,
    },
    mutations: {
        setItems(state, items) {
            state.items = items;
        },
    },
    actions: {
        async index({ commit, rootState }) {
            const response = await http.get('admin/users', {params: rootState.route.query});

            commit('setItems', response.data);

            return response;
        },
        async store({ commit }, payload) {
            const response = await http.post('admin/users', payload);

            return response;
        },
        async update({ commit }, payload) {
            const response = await http.patch(`admin/users/${payload.id}`, payload);

            return response;
        },
        async deactivate({ commit }, id) {
            const response = await http.patch(`admin/users/${id}/deactivate`);

            return response;
        },
        async activate({ commit }, id) {
            const response = await http.patch(`admin/users/${id}/activate`);

            return response;
        },
        async delete({ commit }, id) {
            const response = await http.delete(`admin/users/${id}`);

            return response;
        },
    }
}